import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

type Props = {
  setShowInviteNudge: (show: boolean) => void;
  onAddPeoplePress?: () => void;
  description?: string;
};

export const GotCrewForThisJobBanner: React.FC<Props> = ({
  setShowInviteNudge,
  onAddPeoplePress,
  description,
}) => {
  const { t } = useTranslation('models');

  return (
    <Box
      flexShrink={0}
      marginHorizontal='l'
      marginTop='m'
      marginBottom='xxs'
      borderRadius='xs'
      backgroundColor='black'
      flexDirection='row'
      alignItems='center'
      padding='m'>
      <Box
        width={40}
        height={40}
        borderRadius='l'
        justifyContent='center'
        alignItems='center'
        flexShrink={0}
        style={{
          backgroundColor: 'rgba(3, 91, 96, 0.5)',
        }}>
        <Icon variant='l' name='UserPlus' color='greenBrand' />
      </Box>

      <Box style={{ flex: 1 }} ml='m'>
        <Text variant='heading2' color='white'>
          {t('nudge.gotCrewForThisJob.title')}
        </Text>
        <Text variant='body' color='white' mt='xxs'>
          {description ?? t('nudge.gotCrewForThisJob.description')}
        </Text>
      </Box>

      {/* White backing so the translucent hover shows as a lighter green
          instead of letting the black banner darken it (TA-10891 #17). */}
      <Box backgroundColor='white' borderRadius='xs' overflow='hidden'>
        <Button
          isSmall={true}
          width={150}
          height={56}
          backgroundColor='greenSecondary'
          // TA-10891 #17: hover is greenSecondary at 80% opacity instead of
          // stepping down to greenDark.
          hoverBackgroundColor={`${theme.colors.greenSecondary}CC`}
          onPress={() => {
            setShowInviteNudge(false);
            onAddPeoplePress?.();
          }}>
          <Text variant='typography' color='white'>
            {t('nudge.gotCrewForThisJob.ctaLabel')}
          </Text>
        </Button>
      </Box>
    </Box>
  );
};
